import { Box, Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwColorInput, LwImageInput } from 'redesign';
import type { SettingEditThemeFormData } from './setting-edit-theme-form.types';

export { type SettingEditThemeFormData } from './setting-edit-theme-form.types';

export const SettingEditThemeForm = () => {
  const { control } = useFormContext<SettingEditThemeFormData>();
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Box>
      <Grid container item spacing={2} sm={6}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h6">{t('settings-theme.colors.title')}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="colors.primaryColor"
            label={t('settings-theme-primary.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="colors.secondaryColor"
            label={t('settings-theme-secondary.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="colors.primaryAccent"
            label={t('settings-theme-primary_accent.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LwColorInput
            name="colors.secondaryAccent"
            label={t('settings-theme-secondary_accent.title')}
            control={control}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Typography variant="h6">{t('settings-theme.logos.title')}</Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <LwImageInput
            name="logo.portalLogoWide"
            label={t('settings-theme.portalLogoWide')}
            control={control}
            dropzoneWidth={180}
            dropzoneHeight={40}
            data-testid="theme-logo-wide"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <LwImageInput
            name="logo.portalLogoSquare"
            label={t('settings-theme.portalLogoSquaretitle')}
            control={control}
            dropzoneWidth={80}
            dropzoneHeight={80}
            data-testid="theme-logo-square"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
